import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Form } from 'semantic-ui-react';
import { EventWizardData } from 'stores/events/creation-wizard-store';
import TailwindNonMachineRelatedComponent, {
  TailwindNonMachineRelatedComponentViewModel
} from 'site/pages/shared/events-and-requests/non-machine-related/non-machine-related-tw';

interface NonMachineRelatedSubjectStepProps extends WithTranslation {
  wizardData: EventWizardData;
  onValueChanged: (...changes: [string, any][]) => void;
}

interface MobileNonMachineRelatedSubjectStepState {
  wizardData: EventWizardData;
  clusterActive: boolean;
  functionalAreaActive: boolean;
  trainingNameActive: boolean;
}

class MobileNonMachineRelatedSubjectStep extends Component<NonMachineRelatedSubjectStepProps, MobileNonMachineRelatedSubjectStepState> {
  constructor(props) {
    super(props);

    this.state = {
      wizardData: props.wizardData,
      clusterActive: this.isClusterActive(),
      functionalAreaActive: this.isFunctionalAreaActive(),
      trainingNameActive: this.isTrainingNameActive()
    };
  }

  private isClusterActive(): boolean {
    return this.props.wizardData.nmrClusterId != null;
  }

  private isFunctionalAreaActive(): boolean {
    return this.props.wizardData.nMRFunctionalAreaId != null;
  }

  private isTrainingNameActive(): boolean {
    return this.props.wizardData.nMRTrainingNameId != null;
  }

  UNSAFE_componentWillReceiveProps(nextProps: NonMachineRelatedSubjectStepProps) {
    if (nextProps && nextProps !== this.props) {
      this.setState({
        wizardData: nextProps.wizardData
      });
    }
  }

  private handleOnNonMachineRelatedChange = (value: TailwindNonMachineRelatedComponentViewModel) => {
    const changes: [string, any][] = [
      ['nmrCluster', value.cluster],
      ['nmrFunctionalArea', value.functionalArea],
      ['nmrFunctionalSubArea', value.functionalSubArea],
      ['nmrTrainingName', value.trainingName],
      ['nmrClusterId', value.cluster?.id],
      ['nMRFunctionalAreaId', value.functionalArea?.id],
      ['nMRFunctionalSubAreaId', value.functionalSubArea?.id],
      ['nMRTrainingNameId', value.trainingName?.id]
    ];

    this.props.onValueChanged(...changes);
  };

  render() {
    const { t, wizardData } = this.props;

    const nonMachineRelated: TailwindNonMachineRelatedComponentViewModel = {
      cluster: wizardData.nmrCluster,
      functionalArea: wizardData.nmrFunctionalArea,
      functionalSubArea: wizardData.nmrFunctionalSubArea,
      trainingName: wizardData.nmrTrainingName
    };

    return (
      <Form className="wizard__step2__machine-related" loading={false}>
        <h3 className="machine-related__title">{t('NON-MACHINE RELATED')}</h3>
        <div className="flex flex-col space-y-4 wizard__step2__machine-related__content">
          <div className="form__event-details-tab__mr__pattern form__event-details-tab__element wizard__mr-table mr-table-component__common-styles">
            <TailwindNonMachineRelatedComponent
              category={wizardData.category}
              className="wizard__no-machine-related"
              value={nonMachineRelated}
              readOnly={false}
              onChange={this.handleOnNonMachineRelatedChange}
            />
          </div>
        </div>
      </Form>
    );
  }
}

export default withTranslation()(MobileNonMachineRelatedSubjectStep);
